document.addEventListener("DOMContentLoaded", function () {
    const updateBackground = (target) => {
        const value = parseInt(target.value);
        const min = target.min;
        const max = target.max;
        const selectedPercentage = (value - min) / (max - min) * 100;
        target.style.background = `linear-gradient(to right,#006589,#006589 ${selectedPercentage}%,#DCDCDC 0%)`;
    }

    function handleLabelClick(e) {
        e.stopPropagation();
        e.preventDefault();
        const target = e.currentTarget;
        const labelFor = target.getAttribute("for");
        const input = document.getElementById(labelFor);
        const isRadioButton = input.type.toLowerCase() === "radio";
        const toggleValue = isRadioButton ? true : !input.checked;
        if (isRadioButton) {
            const fieldSet = target.parentElement;
            // Uncheck all other radio buttons in the fieldset
            const otherRadioButtons = [...fieldSet.querySelectorAll("input")].filter(x => x.type.toLowerCase() === "radio" && x.id !== labelFor);
            otherRadioButtons.forEach(x => {
                x.checked = false;
                x.dispatchEvent(new Event("change"));
            });
        }
        input.checked = toggleValue;
        input.dispatchEvent(new Event("change"));
    }

    const formChoices = document.querySelectorAll(".FormChoice:not(.FormChoice--Image) > fieldset");
    formChoices.forEach(fieldSet => {
        const inputs = fieldSet.querySelectorAll("input");

        inputs.forEach((input, index) => {
            const label = input.parentElement;
            const id = `${input.name}_${index}`;
            input.id = id;
            label.for = id;
            const targetType = input.type.toLowerCase();
            if (targetType === "radio") {
                label.classList.add("FormChoice__Label", "FormChoice__Label--Radio");
            } else if (targetType === "checkbox") {
                label.classList.add("FormChoice__Label", "FormChoice__Label--Checkbox");
            }
            label.setAttribute("for", input.id);

            label.addEventListener("click", handleLabelClick);

            if (fieldSet.checked) {
                label.classList.add("FormChoice__Label--Checked");
            } else {
                label.classList.remove("FormChoice__Label--Checked");
            }
            input.addEventListener("change", e => {
                if (e.currentTarget.checked) {
                    label.classList.add("FormChoice__Label--Checked");
                } else {
                    label.classList.remove("FormChoice__Label--Checked");
                }
            });
        });
    })

    const uploadFields = [...document.querySelectorAll('.FormFileUpload__Input')];
    uploadFields.forEach(input => {
        const button = document.createElement('button');
        button.addEventListener("click", (e) => {
            e.preventDefault();
            input.click()
        });
        button.classList.add('FormFileUpload__Button');
        button.innerHTML = 'Välj fil';
        button.dataset.id = input.id;
        input.parentElement.insertBefore(button, input);
    })

    Array.from(formChoices).filter(x => x.disabled).forEach(x => x.parentElement.classList.add("FormChoice__Label--Disabled"));
    const progress = document.querySelector('.Form__NavigationBar__ProgressBar')
    if (progress) {
        const form = progress.closest('form');
        form.classList.add('EPiServerForms--progress-bar')
    }

    const formRangeContainers = document.querySelectorAll('.FormRange > span:not([class])');
    formRangeContainers.forEach(container => {
        const inputElem = container.querySelector('input');
        const inputTextbox = document.createElement('input');
        inputTextbox.type = 'number';
        inputTextbox.value = inputElem.value;
        inputTextbox.classList.add('FormTextbox__Input');
        inputTextbox.style.width = '50px';
        inputTextbox.style.marginLeft = '10px';
        inputTextbox.style.textAlign = "center";

        inputTextbox.addEventListener('input', e => {
            const value = parseInt(e.currentTarget.value);
            if (isNaN(value)) {
                return;
            }
            if (value < inputElem.min) {
                e.currentTarget.value = inputElem.min;
            } else if (value > inputElem.max) {
                e.currentTarget.value = inputElem.max;
            }
            inputElem.value = value.toString();
            const event = new Event('input');
            inputElem.dispatchEvent(event);
        });

        inputElem.addEventListener('input', (e) => {
            const target = e.currentTarget
            const value = target.value;

            updateBackground(target);
            inputTextbox.value = value;
        });

        container.appendChild(inputTextbox);
        updateBackground(inputElem);

    });

    const resetButton = document.querySelector('[data-f-type="resetbutton"]');
    if (resetButton) {
        const submitButton = resetButton.parentNode.querySelector('[data-f-type="submitbutton"]');
        submitButton.style.float = "right";
        resetButton.style.float = "left";
    }
});